export const HERO_CONSTANTS = {
  button: {
    label: "Transform Your Network Today",
    link: "#contact-us",
  },
  title: "Intelligent Networking: Secure, Agile, and Software-Defined",
};
